module.exports = __webpack_public_path__ + "img/34.ad213131.png";